const productQuickViewEvents = {
    triggerProductQuickViewChange: 'action:productQuickView:update',
};

class ProductQuickView extends HTMLElement {
    constructor() {
        super();
        this.elementToTargetInsideResponseData = '[product-quick-view]';
        document.addEventListener(
            productQuickViewEvents.triggerProductQuickViewChange,
            (e) => {
                this._renderProductQuickViewElement(e.detail);
            }
        );

        document.addEventListener(_EVENT_HELPER.hideDrawer, (e) => {
            if (e.detail.drawerType == 'options') {
                this._clearDrawerInnerBody();
            }
        });
    }

    connectedCallback() { }

    atc(variant_id, selling_plan_id, quantity) {
        const button = this.querySelector('.quick-view-atc');
        const formData = {
            items: [
                {
                    id: variant_id,
                    quantity: quantity
                }
            ]
        };
        if(selling_plan_id) formData.items[0].selling_plan = selling_plan_id;

        HELPER_UTIL.fetchData({
            method: 'POST',
            config: {
                headers: {
                        'Content-Type': 'application/json'
                    },
            },
            url: `${window.Shopify.routes.root}cart/add.js?sections=${HELPER_UTIL.sectionRenderUtil('cart-drawer').getSectionsString()}`,
            data: JSON.stringify(formData),
            onsuccess: (data) => {
                const cartDrawer = document.querySelector('cart-drawer-component');
                // Render Cart Drawer with data
                if (cartDrawer) {
                    HELPER_UTIL.dispatchCustomEvent(
                        _EVENT_HELPER.triggerCartChange,
                        button,
                        {
                            productVariant: data.variant_id,
                            sections: data.sections,
                        }
                    );
                    HELPER_UTIL.dispatchCustomEvent(
                        _EVENT_HELPER.showDrawer,
                        document,
                        {
                            drawerType: 'cart-drawer',
                        }
                    );
                    console.log(data);
                } else {
                    window.location.href = `${Shopify.routes.root}cart`;
                }
            },
            onerror: (error) => {
                console.log(error);
                if (error.json) {
                    error.json().then((errorObj) => {
                        if (errorObj.status === 422) {
                             // variant add to cart errors
                             HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.triggerVariantAddToCartError, document, {
                                errorObj: errorObj.description,
                            });
                            // Show gift card errors
                            if (
                                errorObj.description.hasOwnProperty('email') ||
                                errorObj.description.hasOwnProperty('send_on')
                            ) {
                                HELPER_UTIL.dispatchCustomEvent(
                                    _EVENT_HELPER.triggerProductGiftCardError,
                                    this,
                                    {
                                        errorObj: errorObj.description,
                                    }
                                );
                              
                            } else {
                                console.log('error');
                                alert('error');
                            }
                        }
                    });
                } else {
                    HELPER_UTIL.dispatchCustomEvent(
                        _EVENT_HELPER.triggerToastMessage,
                        document,
                        {
                            toastType: 'common-errors',
                            messageType: 'error',
                            message:
                                'Something went went wrong! Please try again',
                        }
                    );
                }
            }
        });
    }

    _clearDrawerInnerBody() {
        try {
            setTimeout(() => {
                this.innerHTML = '';
            }, 400);
        } catch (err) {
            throw new Error(err);
        }
    }

    _updateQuickViewData(responseData, drawerHeadingName) {
        const pageData = new DOMParser().parseFromString(
            responseData,
            'text/html'
        );
        const getQuickViewSection = pageData.querySelector(
            this.elementToTargetInsideResponseData
        );
        if (!getQuickViewSection) throw { sectionError: 'Section not found' };
        const div = document.createElement('div');
        div.append(getQuickViewSection);
        div.querySelector('.drawer__head').innerHTML = drawerHeadingName;
        this.innerHTML = div.innerHTML;
    }

    _triggerCartDrawer() {
        HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.showDrawer, document, {
            drawerType: 'options',
        });
    }

    _initShopifyPaymentButtons() {
        if (!Shopify?.PaymentButton?.init) return;

        Shopify.PaymentButton.init();
    }

    _renderProductQuickViewElement(eventCustomDetails) {
        const { productHandle, swatchChangeVariantId, submitButton, drawerHeadingName } =
            eventCustomDetails;

        // Render button loading State
        HELPER_UTIL.submitButtonState(submitButton).loadingState();

        HELPER_UTIL.fetchData({
            method: 'GET',
            url: `${Shopify.routes.root}products/${productHandle}?variant=${swatchChangeVariantId}&view=product-quick-view`,
            responseType: 'text',
            onsuccess: (data) => {
                if (!data)
                    throw new Error(
                        'No product data found! Check if you sending right product handle'
                    );

                this._updateQuickViewData(data, drawerHeadingName);
                // Initialize Accelerated checkout Payments Buttons
                this._initShopifyPaymentButtons();

                // Render button complete State
                HELPER_UTIL.submitButtonState(submitButton).completeState();

                // Show Cart Drawer
                this._triggerCartDrawer();

                // Add Event Listener to Add to Cart Button
                document.querySelectorAll('.quick-view-atc').forEach(button => {
                  button.addEventListener('click', evt => {
                    evt.preventDefault();
                    const variant_id = this.querySelector('input[type="radio"][name="id"]:checked') ? this.querySelector('input[type="radio"][name="id"]:checked').value : this.querySelector('[type="hidden"][name="id"]').value;
                    const selling_plan_id = this.querySelector('.cart-drawer-subscribe-save__current-selling-plan') ? this.querySelector('.cart-drawer-subscribe-save__current-selling-plan').dataset.id : null;
                    const quantity = this.querySelector('#quantity-product-form-product-quick-view').value;
  
                    this.atc(variant_id, selling_plan_id, quantity);
                  });
                });
            },
            onerror: (error) => {
                /* FIXME : Add error handling by showing error toast */
                console.log(error);
                HELPER_UTIL.dispatchCustomEvent(
                    _EVENT_HELPER.triggerToastMessage,
                    document,
                    {
                        toastType: 'common-errors',
                        messageType: 'error',
                        message: 'Something went went wrong! Please try again',
                    }
                );
            },
            defaultCb: () => {
                // Render default State of button
                setTimeout(() => {
                    HELPER_UTIL.submitButtonState(submitButton).resetState(
                        1000
                    );
                    HELPER_UTIL.submitButtonState(submitButton).disableState(
                        false
                    );
                }, 1000);
            },
        });
    }
}

customElements.get('product-quick-view-component') ||
    customElements.define('product-quick-view-component', ProductQuickView);

class BuyButtonMutationObserver extends MutationObserverComponent {
    constructor() {
        super();
    }

    _updateDrawerHeight() {
        const headerContainerHeight = this.closest("drawer-component").querySelector("[drawer-header]")?.offsetHeight
        const currentButtonContainerHeight = this.querySelector(
            '.product-form__buttons'
        )?.offsetHeight;
        if (!currentButtonContainerHeight) return;
        this.buttonContainerHeight = currentButtonContainerHeight;
        this.closest('drawer-component')?.style.setProperty(
            '--set-container-height',
            `${currentButtonContainerHeight + headerContainerHeight}px`
        );
    }

    _mutationCallback(mutations) {
        mutations.forEach(() => {
            this._updateDrawerHeight();
        });
    }
}

customElements.get('buy-button-mutation-observer') ||
    customElements.define(
        'buy-button-mutation-observer',
        BuyButtonMutationObserver
    );
